import { Navigate, useLocation } from "react-router";
import { useAuth } from "../context/AuthContext";

function Protected({ children }) {
  const { isuserloggedin, role } = useAuth();
  const location = useLocation();

  if (!isuserloggedin) {
    if (location.pathname.startsWith("/admin")) {
      return <Navigate to='/admin/login' state={{ from: location }} replace />;
    }
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  // Prevent non-admin users (students & departments) from accessing admin routes
  if (location.pathname.startsWith("/admin") && role !== "admin") {
    return <Navigate to='/' replace />;
  }

  // Automatically take admins to the admin dashboard if on root route
  if (location.pathname === "/" && role === "admin") {
    return <Navigate to='/admin' replace />;
  }

  return children;
}
export default Protected;

